<template>
  <base-event-log-item
    icon="cloud_upload"
    :researcher="referenceEventLog.eventBy"
    :date="referenceEventLog.createdAt"
    :bottom-node="bottomNode"
  >
    <div
      class="text-overflow-ellipsis"
      :title="referenceEventLog.payload.fileName"
    >
      <span class="font-weight-medium">
        Uploaded &amp; extracted
      </span>
      <span class="font-weight-light">from</span>
      <span class="font-weight-medium">
        {{ referenceEventLog.payload.fileName }}
      </span>
    </div>
  </base-event-log-item>
</template>

<script>
import BaseEventLogItem from './BaseEventLogItem';
import { ReferenceEventLog } from '@/models';

export default {
  name: 'UploadEventLogItem',
  components: { BaseEventLogItem },
  props: {
    referenceEventLog: {
      type: ReferenceEventLog,
      required: true,
    },
    bottomNode: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
.text-overflow-ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
